import React, { useState } from "react";
import { Modal, Stack, Group, TextInput, Button } from "@mantine/core";
import "./CreateQuickLinkModal.css";

interface QuickLinkModalProps {
  opened: boolean;
  onClose: (obj: { webUrl: string; favicon: string } | null) => void;
}

const CreateQuickLinkModal: React.FC<QuickLinkModalProps> = ({
  opened,
  onClose,
}) => {
  const [url, setUrl] = useState("");

  const getFavicon = (webUrl: string): string => {
    try {
      const url = new URL(webUrl);
      return `${url.origin}/favicon.ico`;
    } catch (error) {
      console.error("Invalid URL:", error);
      return "";
    }
  };
  const saveUrl = () => {
    if (url) {
      const hasProtocol = url.startsWith("http://") || url.startsWith("https://");
      const newUrl = hasProtocol ? url : `https://${url}`;
      const favicon = getFavicon(newUrl);
      onClose({
        webUrl: newUrl,
        favicon,
      });
      setUrl("");
    }
  };
  const closeModal = () => {
    onClose(null);
    setUrl("");
  };
  return (
    <Modal
      opened={opened}
      onClose={closeModal}
      title="Create a quick link"
      withCloseButton={false}
      centered
      size="auto"
      classNames={{
        content: "quick-link-modal-root",
        body: "quick-link-modal",
        header: "custom-header",
        title: "custom-title",
        overlay: "custom-overlay",
      }}
    >
      <Stack gap="1rem">
        <TextInput
          label="Enter URL"
          placeholder="URL"
          classNames={{
            input: "url-input",
          }}
          value={url}
          onChange={(event) => {
            setUrl(event.currentTarget.value);
          }}
        />
        <Group justify="end">
          <Button
            variant="filled"
            color="#030102"
            className="!rounded-lg"
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            variant="white"
            color="#030102"
            className="!rounded-lg"
            onClick={saveUrl}
          >
            Save
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default CreateQuickLinkModal;
